import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Bill_item_input } from '../models/accounting/bill_item_input';
import { Statement } from '../models/accounting/statement';
import { I_competition_entry } from '../models/i_competition_entry.interface';
import { Entry_type } from '../models/entry_type';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class QualifyingEntryStatementService {

  constructor(private http: HttpClient) { }

  get(horse_show_id: string, entry_id: string, entry_type_number: number, section_number: number): Promise<Statement> {
    return this.getWithRest('entry_id/' + entry_id + '/horse_show_id/' + horse_show_id + '/entry_type_number/' + entry_type_number + '/section_number/' + section_number);
  }

  private getWithRest(rest_url: string) : Promise<Statement> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'accounting/qualifying_entry_statement/' + rest_url).subscribe((response:any) => {

        if(response.type == 'statement' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

}
